<template>
    <div class="ext-footer-box">
        <div class="ext-footer-main">
            <div class="ext-footer-nav">
                <ul>
                    <li v-for="(vo,index) in help_list" :key="index">
                        <h2>{{vo.title}}</h2>
                        <p v-for="(voo,key) in vo.more" :key="key"><a @click="get_link(voo.id)">{{voo.title}}</a></p>
                    </li>
                    <li>
                      <h2>关于我们</h2>
                      <p><a href="https://parts.franke.cn/store/api/check_html" target="_block">用户协议与隐私政策</a></p>
                      <p><a href="https://www.franke.com" target="_block">Franke</a></p>
                    </li>
                </ul>
                <div class="ext-footer-nav-qrcode">
                    <h2>弗兰卡再供应APP二维码</h2>
                    <img src="@/assets/icon/qrcode.png"/>
                    <p>下载弗兰卡再供应APP</p>
                </div>
            </div>

            <div class="ext-footer-link">
                <p>
                </p>
            </div>

            <div class="ext-footer-copy">
                <ul>
                    <li>{{copyright_info}}</li>
                </ul>
                <ul>
                    <li><a href="https://beian.miit.gov.cn/" target="_block">{{company_icp}}</a></li>
                    <li>联系电话：{{company_tel}}<i></i></li>
                </ul>
            </div>

        </div>

        <div class="ext-right-nav-box">
            <div class="ext-right-nav-menu">
                <ul>
                    <li @click="go_user()">
                        <img src="@/assets/icon/nav/user.png"/>
                        <p>我的资料</p>
                    </li>
                    <li @click="go_cart()">
                        <img src="@/assets/icon/nav/cart.png"/>
                        <a>{{cart_qty}}</a>
                        <p>购物车</p>
                    </li>
                    <li @click="go_like()">
                        <img src="@/assets/icon/nav/like.png"/>
                        <a>{{like_count}}</a>
                        <p>我的收藏</p>
                    </li>
                    <li @click="go_show()">
                        <img src="@/assets/icon/nav/show.png"/>
                        <p>浏览记录</p>
                    </li>
                    <li>
                      <img @click="foot_search_data()" src="@/assets/icon/nav/kf.png"/>
                    </li>
                </ul>
            </div>
            <div class="ext-right-nav-foot">
                <ul>
                    <li @click="go_home()">
                        <img src="@/assets/icon/nav/home.png"/>
                        <p>首页</p>
                    </li>
                    <li @click="go_feedback()">
                        <img src="@/assets/icon/nav/book.png"/>
                        <p>反馈</p>
                    </li>
                    <li @click="go_top()">
                        <img src="@/assets/icon/nav/top.png"/>
                        <p>顶部</p>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>
import {getUserId, ajax, Encrypt, Decrypt, webUrl} from '@/utils/extend'
import $ from 'jquery'
export default {
  name: 'ExtFooter',
  data () {
    return {
      msg: '这是首页',
      search_goods: '',
      cart_qty: 0,
      like_count: 0,
      select_id: 0,
      copyright_info: '',
      company_icp: '',
      company_tel: '',
      help_list: []
    }
  },
  mounted () {
    var params = this.$route.query

    $('.ext-right-nav-menu ul li').hover(function () {
      $(this).find('p').show()
    }, function () {
      $(this).find('p').hide()
    })

    $('.ext-right-nav-foot ul li').hover(function () {
      $(this).find('p').show()
    }, function () {
      $(this).find('p').hide()
    })

    if (params.v) {
      this.select_id = Decrypt(params.v)
    } else {
      this.select_id = ''
    }

    this.get_cart_count()
    this.load_data()
    this.go_top()
  },
  methods: {
    go_home () {
      var params = this.$route
      if (params.name !== 'home') {
        this.$router.push({path: '/', query: {}})
      }
    },
    go_user () {
      var params = this.$route
      if (params.name !== 'store_info') {
        this.$router.push({path: '/store/store_info', query: {}})
      }
    },
    go_cart () {
      var params = this.$route
      if (params.name !== 'cart_list') {
        this.$router.push({path: '/cart/cart_list', query: {}})
      }
    },
    go_like () {
      var params = this.$route
      if (params.name !== 'collect') {
        this.$router.push({path: '/store/collect', query: {}})
      }
    },
    go_show () {
      var params = this.$route
      if (params.name !== 'browse') {
        this.$router.push({path: '/store/browse', query: {}})
      }
    },
    go_feedback () {
      var params = this.$route
      if (params.name !== 'feedback') {
        this.$router.push({path: '/store/feedback', query: {}})
      }
    },
    go_top () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    get_cart_count () {
      var that = this
      ajax({
        url: '/store/order/user_cart_list',
        method: 'post',
        data: {
          uid: getUserId(),
          target_id: 1
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.cart_qty = ret.data.cart_count
        } else {
          that.cart_qty = 0
        }
      })

      ajax({
        url: '/store/order/user_like_count',
        method: 'post',
        data: {
          uid: getUserId(),
          target_id: 1
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.like_count = ret.data.like_count
        } else {
          that.like_count = 0
        }
      })
    },
    foot_search_data () {
      var params = this.$route
      if (params.name !== 'customer_service') {
        this.$router.push({path: '/store/customer_service', query: {}})
      }
    },
    get_link (id) {
      var selectId = this.select_id
      if (selectId !== id) {
        this.$router.push({path: '/store/help', query: {v: Encrypt(id)}})
      }
    },
    load_data () {
      var that = this
      ajax({
        url: '/store/api/help_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.help_list = ret.data
        } else {
          that.help_list = []
        }
      })

      ajax({
        url: '/store/api/get_app_copy',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.copyright_info = ret.data.copyright_info
          that.company_icp = ret.data.company_icp
          that.company_tel = ret.data.company_tel
        } else {
          that.copyright_info = ''
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }

input { box-sizing:border-box;outline:none;}

.ext-footer-box { width:100%; height:350px; background: #f4f4f4; border-top:1px solid #dedede;}
.ext-footer-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
    .ext-footer-nav { width:100%; height:auto; margin-top:20px; flex-flow:row; align-content:flex-start; justify-content:space-between; }
        .ext-footer-nav ul { width:800px; height:auto; list-style: none; margin:0px; padding:0px; flex-flow:row; justify-content:flex-start;}
            .ext-footer-nav ul li { width:160px; height:170px; padding-left:15px; border-left:0px solid #e0e0e0; position: relative; flex-wrap:wrap; align-content:flex-start;}
                .ext-footer-nav ul li h2 { width:100%; height:30px; line-height:30px; font-size:14px; color:#666666; font-weight: bold;}
                .ext-footer-nav ul li p { width:100%; height:24px; margin:0px; line-height:24px; cursor: pointer; font-size:12px; color:#666666; }
                .ext-footer-nav ul li p a { font-size:12px; color:#666666;}
                .ext-footer-nav ul li p a:hover { color:#d81e06;}
        .ext-footer-nav-qrcode { width:150px; height:170px; flex-wrap:wrap; align-content:flex-start;}
            .ext-footer-nav-qrcode h2 { width:150px; height:24px; text-align:center; margin:0px; padding:0px; justify-content:center; line-height:24px; font-size:12px; color:#666666;}
            .ext-footer-nav-qrcode img { width:130px; height:130px; margin:0px 10px;}
            .ext-footer-nav-qrcode p { width:150px; height:24px; margin:0px; text-align:center; justify-content:center; line-height:24px; font-size:12px; color:#666666;}
    .ext-footer-link { width:100%; height:30px; padding:0px 30px; margin-top:20px; border-top:1px solid #dedede;}
        .ext-footer-link p { width:100%; height:40px; line-height:40px; margin:0px; flex-flow:row; justify-content:flex-start;}
        .ext-footer-link p a { width:auto; height:40px; cursor: pointer; position: relative; line-height:40px; padding:0px 10px; font-size:12px; color:#666666;}
        .ext-footer-link p a i { width:1px; height:12px; position:absolute; top:15px; left:0px; border-right: 1px solid #cccccc; }
        .ext-footer-link p a:hover  { color:#d81e06;}
    .ext-footer-copy { width:100%; height:20px;margin-top:20px;flex-wrap:wrap; align-content:flex-start;}
        .ext-footer-copy ul { width:100%; height:24px; list-style: none; line-height:24px; flex-flow:row; justify-content:center; margin:0px;}
        .ext-footer-copy ul li { width:auto; height:24px; font-weight: normal; position: relative; line-height:24px; padding:0px 10px; font-size:12px; color:#666666;}
        .ext-footer-copy ul li i { width:1px; height:12px; position:absolute; top:3px; left:0px; border-right: 1px solid #cccccc; }
        .ext-footer-copy ul li a { color:#666666; cursor: pointer;}
        .ext-footer-copy ul li a:hover  { color:#d81e06;}

.ext-right-nav-box { width:35px; height:100%; position: fixed; border-right:7px solid #918e89; right:0px; top:0px; flex-wrap:wrap; align-content:flex-start;}

    .ext-right-nav-menu  { width: 35px; height:auto; position: absolute; right:-3px; top:30%;}
        .ext-right-nav-menu ul { width:35px; height: auto; margin:0px; padding:0px; list-style: none; flex-wrap:wrap; align-content:flex-start;}
        .ext-right-nav-menu ul li { width:35px; height:35px; position: relative; cursor: pointer; margin:2px 0px 0px 0px; border-radius: 4px; padding:0px; background: #918e89;}
        .ext-right-nav-menu ul li img { width:20px; height:20px; margin:7px; padding:0px;}
        .ext-right-nav-menu ul li a { position: absolute; right:0px; top:0px; font-size:12px; height:16px; line-height:16px; color:#ffffff; background: #d81e06; border-radius: 45px; margin:0px; padding:0px 5px;}
        .ext-right-nav-menu ul li a:hover { color:#d81e06; background: #ffffff; border:1px solid #d81e06;}
        .ext-right-nav-menu ul li:hover { background: #d81e06;}
        .ext-right-nav-menu ul li:hover a { background: #ffffff; border:1px solid #d81e06;color:#d81e06;}
        .ext-right-nav-menu ul li p { width:60px; height:35px; display: none; text-align: center; border-radius: 5px 0px 0px 5px; justify-content: center; line-height:35px; position: absolute; right:33px; top:0px; font-size:12px; background: #d81e06; color:#ffffff;}
        .ext-right-nav-menu ul li p a { width:150px; height:25px; border-radius: 0px; margin:5px; border:1px solid #d81e06;}
        .ext-right-nav-menu ul li p a input { width:140px; height:22px; line-height:22px; font-size:12px; color:#333333; border:0px; margin:0px; padding:0px;}
    .ext-right-nav-foot  { width: 35px; height:120px; position: absolute; right:-3px; bottom:0px;}
        .ext-right-nav-foot ul { width:35px; height: auto; margin:0px; padding:0px; list-style: none; flex-wrap:wrap; align-content:flex-start;}
        .ext-right-nav-foot ul li { width:35px; height:35px; position: relative; cursor: pointer; margin:2px 0px 0px 0px; border-radius: 4px; padding:0px; background: #918e89;}
        .ext-right-nav-foot ul li:hover { background: #d81e06;}
        .ext-right-nav-foot ul li img { width:20px; height:20px; margin:7px; padding:0px;}
        .ext-right-nav-foot ul li p { width:50px; height:35px; display: none; text-align: center; border-radius: 5px 0px 0px 5px; justify-content: center; line-height:35px; position: absolute; right:33px; top:0px; font-size:12px; background: #d81e06; color:#ffffff;}

</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue